import React from "react";
import {
    RadioGroup,
    Grid,
    TextField,
    Button,
    withStyles,
    FormControlLabel,
    Radio,
    MenuItem,
    FormGroup,
    Checkbox,
    InputLabel,
    Select,
    Input,
    FormControl
  } from "material-ui";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Tooltip from "material-ui/Tooltip";
import Title from "../../ui/title";
import Content from "../../ui/content";
import styles from "./styles";
import ConfirmDialog from "../../common/dialog/confirm";
import { withRouter } from "react-router-dom";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { validateFormData } from "../../../common/formtool";
import { FiberLengthLossEnum } from "./fiberlengthlossenum";
import { ToInt, ToReal, ToDuration } from "../../../common/datatypetool";
import { feetToMetersDecimal, metersToFeetDecimal } from "../../../common/utils";
import { element } from "prop-types";
import { translate } from "exif-orientation-image";

class FiberLengthLoss extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fiberLengthLossSettingType: "",
      isChanged: false,
      showConfirmBack: false,
      sfpType: [],
      fiberType: [],
      connectorType: [],
      testDirection: [],
      testMethod: [],
      limitType: [],
      validTestLimits: [],
      validConnectorTypes: [],
      validFiberTypes: [],
      refractiveIndex: 1.4930,
      verifyLength: true,
      maxLength: 1000,
      spliceCount: 0,
      spliceLoss: 0.3,
      adapterCount: 0,
      adapterLoss: 0.75,
      stdAttenuation: true,
      fiberAttenuation: 0.0,
      defaultMaxLength: null,
      defaultMaxLengthSM: null,
      defaultMaxLengthLimit: null,
      defaultRefractiveIndex: 1.4930,
      defaultSpliceCount: 0,
      defaultSpliceLoss: 0.3,
      defaultAdapterCount: 0,
      defaultAdapterLoss: 0.75,
      defaultFiberAttenuation: 0.0,
      noLimit: false,
      customLimit: false,
      errors: {},
      showRestoreConfirm: false,
      isFiberLengthLossUpdated: false,
      fiberLengthLossInitialised: false,
      testMethodTooltipHover: false,
      testMethodTooltipFocus: false
    };
  }

  setTestMethodTooltipHover = (value) => {
    if (value == this.state.testMethodTooltipHover) {
      return;
    }
    this.setState({
      testMethodTooltipHover: value
    });
  };

  setTestMethodTooltipFocus = (value) => {
    if (value == this.state.testMethodTooltipFocus) {
      return;
    }
    this.setState({
      testMethodTooltipFocus: value
    });
  };

  toFixed = (e, numberOfDigit, newErrors) => {
    let value = ToReal(e.target.value);
    value = value.split(".");
    if (value.length > 2) {
      this.setState({ errors: { [e.target.name]: {} } });
    } else if (value.length === 1) {
      this.setState({
        [e.target.name]: value[0],
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else {
      if (value[1].length > numberOfDigit) {
        e.preventDefault();
      } else {
        this.setState({
          [e.target.name]: ToReal(e.target.value),
          isChanged: true,
          isRestore: false,
          errors: newErrors
        });
      }
    }
  };

  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  onBackYesClick = () => {
    this.setState({
      showConfirmBack: false
    });
    this.onFiberLengthLossSave();
  };

  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };

  getRefractiveIndexForFiberType = (type) => {
    let riEntry = FiberLengthLossEnum.RefractiveIndexForFiberType.at(type);
    if (riEntry === undefined) {
      return this.state.defaultRefractiveIndex;
    }
    return riEntry.value;
  }
  getLimitsForFiberType = (type) => {
    let limitsEntry = FiberLengthLossEnum.LimitsForFiberType.at(type);
    if (limitsEntry === undefined) {
      return FiberLengthLossEnum.LimitType;
    }
    let limits = FiberLengthLossEnum.LimitType.filter(
      element => limitsEntry.value.some(e => e.limit == element.key)
    );
    let currentSelectedLimitType = this.state.limitType[0] ? parseInt(this.state.limitType[0].key) : 0;
    if ((currentSelectedLimitType > 1) && (limits !== undefined) && (limits.length > 2) && !limits.some(e => e.key == currentSelectedLimitType)) {
      this.setState({
        limitType: this.mapEnumValue(
          limits[2].key,
          "limittype"
        )
      });
    }
    return limits;
  };

  getConnectorTypesForTestMethod = (jumper) => {
    let connectorTypes
    if (jumper === 0) {
      connectorTypes = FiberLengthLossEnum.ConnectorType.filter(
        element => element.value == "LC"
      );
    }
    else {
      connectorTypes = FiberLengthLossEnum.ConnectorType;
    }
    return connectorTypes;
  }

  getFiberTypesForSFPType = (simplex) => {
    let fiberTypes
    if (simplex) {
      fiberTypes = FiberLengthLossEnum.FiberType.filter(
        element => element.value == "OS1" || element.value == "OS2"
      );
    }
    else {
      fiberTypes = FiberLengthLossEnum.FiberType;
    }

    if (this.state.fiberType && this.state.fiberType[0]) {
      let types = fiberTypes.filter(
        element => element.key === this.state.fiberType[0].key
      );
      if (types.length > 0) {
        return fiberTypes;
      }

      this.setState({
        fiberType: this.mapEnumValue(parseInt(fiberTypes[0].key), "fibertype"),
        validTestLimits: this.getLimitsForFiberType(parseInt(fiberTypes[0].key))
      });
    }

    return fiberTypes;
  }

  getLimitInfo = () => {
    let limittype = this.state.limitType[0] ? parseInt(this.state.limitType[0].key) : 0;
    let fibertype = this.state.fiberType[0] ? parseInt(this.state.fiberType[0].key) : 0;
    let limitsEntry = FiberLengthLossEnum.LimitsForFiberType.at(fibertype);
    if (limitsEntry === undefined) {
      return undefined;
    }
    let limitData = limitsEntry.value.filter(
      e => e.limit === limittype
    );
    if ((limitData[0] === undefined) || (limitData[0].wavelength == 0)) {
      return undefined;
    }
    return limitData[0];
  };

  getLimitInfoText = (translate) => {
    let limitData = this.getLimitInfo()
    if (limitData === undefined) {
      return '';
    }
    let lengthlimit = limitData.lengthlimit + translate('m');
    if (this.props.lengthMeasurementUnit === "feet") {
      lengthlimit = metersToFeetDecimal(limitData.lengthlimit) + translate('ft');
    }
    return '@' + limitData.wavelength + 'nm: ' + translate('Length') + ' \u2264' + lengthlimit + '  ' + translate('fiber_insertionloss_heading') + ' \u2264 ' + limitData.losslimit + 'dB';
  };

  getLimitInfoLengthLimit = (maxLength) => {
    let limitData = this.getLimitInfo()
    if (limitData === undefined) {
      return maxLength;
    }
    return (this.props.lengthMeasurementUnit === "feet") ? metersToFeetDecimal(limitData.lengthlimit) : limitData.lengthlimit;
  };

  getLimitInfoLossLimit = () => {
    let limitData = this.getLimitInfo()
    if (limitData === undefined) {
      return 0.0;
    }
    return limitData.losslimit;
  };

  translateElements = (elements) => {
    const { translate } = this.props;
    if (elements !== undefined) {
      elements.forEach(e => {
        e.value = translate(e.value);
      });
    }
    return elements;
  };

  mapEnumValue = (key, type) => {
    switch (type.toLowerCase()) {
      case "sfptype": {
        return FiberLengthLossEnum.SFPType.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "fibertype": {
        return FiberLengthLossEnum.FiberType.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "connectortype": {
        return FiberLengthLossEnum.ConnectorType.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "limittype": {
        this.setState({
          noLimit: parseInt(key) === 0,
          customLimit: parseInt(key) === 1
        });
        let limitFound = FiberLengthLossEnum.LimitType.filter(
          enumType => enumType.key === parseInt(key)
        );
        if ((limitFound !== undefined) && ((limitFound[0].value === "test_standard_custom") || (limitFound[0].value === "none_constant"))) {
          return limitFound;
        }
        return limitFound;
      }
      case "testmethod": {
        return FiberLengthLossEnum.TestMethod.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "testdirection": {
        return FiberLengthLossEnum.TestDirection.filter(
          enumType => enumType.key === parseInt(key));
      }
    }
  };

  updateFiberLengthLoss = (fiberLengthLoss) => {
    let lengthInFeet = (this.props.lengthMeasurementUnit === 'feet') ? true : false;
    let maxLengthInMeters = parseFloat(fiberLengthLoss.maxlength);
    this.setState({
        sfpType: this.mapEnumValue(
          fiberLengthLoss.singlefiber === true ? 1 : 0,
          "sfptype"
        ),
        fiberType: this.mapEnumValue(
          fiberLengthLoss.fibertype,
          "fibertype"
        ),
        connectorType: this.mapEnumValue(
          fiberLengthLoss.connectortype,
          "connectortype"
        ),
        limitType: this.mapEnumValue(
          fiberLengthLoss.fiberlimit,
          "limittype"
        ),
        testMethod: this.mapEnumValue(
          fiberLengthLoss.cordref,
          "testMethod"
        ),
        testDirection: this.mapEnumValue(
          fiberLengthLoss.direction,
          "testdirection"
        ),
        refractiveIndex: parseFloat(fiberLengthLoss.refractiveindex),
        verifyLength: fiberLengthLoss.verifylength ? true : false,
        maxLength: (lengthInFeet) ? parseFloat(metersToFeetDecimal(maxLengthInMeters).toFixed(4)) : maxLengthInMeters,
        spliceCount: parseInt(fiberLengthLoss.splicecount),
        spliceLoss: parseFloat(fiberLengthLoss.spliceloss),
        adapterCount: parseInt(fiberLengthLoss.adaptercount),
        adapterLoss: parseFloat(fiberLengthLoss.adapterloss),
        stdAttenuation: fiberLengthLoss.stdattenuation ? true : false,
        fiberAttenuation: parseFloat(fiberLengthLoss.fiberattenuation),
        validTestLimits: this.getLimitsForFiberType(parseInt(fiberLengthLoss.fibertype)),
        validConnectorTypes: this.getConnectorTypesForTestMethod(parseInt(fiberLengthLoss.cordref)),
        validFiberTypes: this.getFiberTypesForSFPType(fiberLengthLoss.singlefiber)
    });
    if (this.state.defaultMaxLength === null) {
      this.setState({
        defaultMaxLength: (lengthInFeet) ? metersToFeetDecimal(1000) : 1000,
        defaultMaxLengthSM: (lengthInFeet) ? metersToFeetDecimal(10000) : 10000,
        defaultMaxLengthLimit: (lengthInFeet) ? metersToFeetDecimal(40000) : 40000,
      });
    }
  };

  onChange = e => {
    const {
      fiberLengthLoss,
      defaultMaxLength,
      defaultMaxLengthSM
    } = this.state;
    let validateErrors = this.state.errors;
    const { translate } = this.props;
    switch (e.target.name) {
        case "sfpType":
          this.setState({
            sfpType: this.mapEnumValue(e.target.value, "sfptype"),
            isChanged: true,
            isRestore: false,
            validFiberTypes: this.getFiberTypesForSFPType(parseInt(e.target.value))
          });
          break;
        case "fiberType":
          this.setState({
            fiberType: this.mapEnumValue(e.target.value, "fibertype"),
            isChanged: true,
            isRestore: false
          });
          this.setState({
            validTestLimits: this.getLimitsForFiberType(parseInt(e.target.value)),
            refractiveIndex: this.getRefractiveIndexForFiberType(parseInt(e.target.value))
          });
          if (this.state.limitType[0].key == 1) { // custom limit
            this.setState({
              maxLength: (parseInt(e.target.value) < 5) ? defaultMaxLength : defaultMaxLengthSM
            });
          }
          break;
        case "connectorType":
          this.setState({
            connectorType: this.mapEnumValue(e.target.value, "connectortype"),
            isChanged: true,
            isRestore: false
          });
          break;
        case "limitType":
          this.setState({
            limitType: this.mapEnumValue(e.target.value, "limittype"),
            isChanged: true,
            isRestore: false
          });
          if (parseInt(e.target.value) == 1) { // custom limit
            this.setState({
              maxLength: (parseInt(this.state.fiberType[0].key) < 5) ? defaultMaxLength : defaultMaxLengthSM
            });
          }
          break;
        case "testMethod":
          this.setState({
            testMethod: this.mapEnumValue(e.target.value, "testmethod"),
            validConnectorTypes: this.getConnectorTypesForTestMethod(parseInt(e.target.value)),
            isChanged: true,
            isRestore: false
          });
          // force LC connector, if 1 Jumper test method selected
          if (parseInt(e.target.value) === 0) {
            this.setState({
              connectorType: this.mapEnumValue(0, "connectortype")
            });
          }
          break;
        case "testDirection":
          this.setState({
            testDirection: this.mapEnumValue(e.target.value, "testdirection"),
            isChanged: true,
            isRestore: false
          });
          break;
        case "refractiveIndex":
          delete validateErrors[e.target.name];
          this.toFixed(e, 4, validateErrors);
          this.setState({
            refractiveIndex: ToReal(e.target.value)
          });
          break;
        case "verifyLength":
          this.setState({
            verifyLength: e.target.checked,
            isChanged: true,
            isRestore: false
          });
          break;
        case "maxLength":
          this.setState({
            maxLength: ToReal(e.target.value),
            isChanged: true,
            isRestore: false
          });
          break;
        case "spliceCount":
          this.setState({
            spliceCount: ToInt(e.target.value),
            isChanged: true,
            isRestore: false
          });
          break;
        case "spliceLoss":
          this.setState({
            spliceLoss: ToReal(e.target.value),
            isChanged: true,
            isRestore: false
          });
          break;
        case "adapterCount":
          this.setState({
            adapterCount: ToInt(e.target.value),
            isChanged: true,
            isRestore: false
          });
          break;
        case "adapterLoss":
          this.setState({
            adapterLoss: ToReal(e.target.value),
            isChanged: true,
            isRestore: false
          });
          break;
        case "stdAttenuation":
          this.setState({
            stdAttenuation: e.target.checked,
            isChanged: true,
            isRestore: false
          });
          break;
        case "fiberAttenuation":
          this.setState({
            fiberAttenuation: ToReal(e.target.value),
            isChanged: true,
            isRestore: false
          });
          break;
    }
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };

  onRestoreConfirm = () => {
    this.updateFiberLengthLoss(this.props.fiberLengthLoss);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  renderValue = selectedValue => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };

  renderTranslatedValue = (selectedValue, translate) => {
    return selectedValue && selectedValue.length && translate(selectedValue[0].value);
  };

  renderLimitType = (selectedValue, translate) => {
    if (selectedValue && selectedValue.length) {
      let value = selectedValue[0].value;
      if (value == "none_constant" || value == "test_standard_custom") {
        return translate(value);
      }
      return value;
    }
    return undefined;
  };

  onFiberLengthLossSave = () => {
    const {
      sfpType,
      fiberType,
      connectorType,
      limitType,
      testMethod,
      testDirection,
      refractiveIndex,
      verifyLength,
      maxLength,
      spliceCount,
      spliceLoss,
      adapterCount,
      adapterLoss,
      stdAttenuation,
      fiberAttenuation,
      defaultMaxLength,
      defaultMaxLengthLimit,
      defaultRefractiveIndex,
      defaultSpliceCount,
      defaultSpliceLoss,
      defaultAdapterCount,
      defaultAdapterLoss,
      defaultFiberAttenuation,
      noLimit,
      customLimit
    } = this.state;
    const { translate, isTestEdit } = this.props;

    let validationObj = {
      refractiveIndex: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 1.3000,
          maxValue: 1.5500,
          message: translate("formfield_error_general_required"),
        },
      },
      spliceCount: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0,
          maxValue: 8,
          message: translate("formfield_error_general_required"),
        },
      },
      spliceLoss: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0.0,
          maxValue: 5.0,
          message: translate("formfield_error_general_required"),
        },
      },
      adapterCount: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0,
          maxValue: 8,
          message: translate("formfield_error_general_required"),
        },
      },
      adapterLoss: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0.0,
          maxValue: 5.0,
          message: translate("formfield_error_general_required"),
        },
      },
      fiberAttenuation: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0.0,
          maxValue: 5.0,
          message: translate("formfield_error_general_required"),
        },
      },
      maxLength: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0,
          maxValue: defaultMaxLengthLimit,
          message: translate("formfield_error_general_required"),
        },
      },
    };

    let errors = validateFormData(
      { refractiveIndex, spliceCount, spliceLoss, adapterCount, adapterLoss, fiberAttenuation, maxLength },
      validationObj
    );

    if (noLimit || !verifyLength) {
      delete errors["maxLength"];
      this.setState({
        maxLength: defaultMaxLength
      });
    }
    if (noLimit || !customLimit) {
      delete errors["spliceCount"];
      delete errors["spliceLoss"];
      delete errors["adapterCount"];
      delete errors["adapterLoss"];
      delete errors["fiberAttenuation"];
      this.setState({
        spliceCount: defaultSpliceCount,
        spliceLoss: defaultSpliceLoss,
        adapterCount: defaultAdapterCount,
        adapterLoss: defaultAdapterLoss,
        fiberAttenuation: defaultFiberAttenuation
      });
    }

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      let maxLengthInMeters = (noLimit || !verifyLength) ? defaultMaxLength : parseFloat(maxLength)
      if (this.props.lengthMeasurementUnit === 'feet') {
        maxLengthInMeters = parseFloat(feetToMetersDecimal(maxLengthInMeters).toFixed(4));
      }
      const payload = {
        singlefiber: parseInt(sfpType[0].key) === 1,
        fibertype: parseInt(fiberType[0].key),
        connectortype: parseInt(connectorType[0].key),
        fiberlimit: parseInt(limitType[0].key),
        direction: parseInt(testDirection[0].key),
        cordref: parseInt(testMethod[0].key),
        refractiveindex: parseFloat(refractiveIndex),
        splicecount: (noLimit || !customLimit) ? defaultSpliceCount : parseInt(spliceCount),
        spliceloss: (noLimit || !customLimit) ? defaultSpliceLoss : parseFloat(spliceLoss),
        adaptercount: (noLimit || !customLimit) ? defaultAdapterCount : parseInt(adapterCount),
        adapterloss: (noLimit || !customLimit) ? defaultAdapterLoss : parseFloat(adapterLoss),
        stdattenuation: stdAttenuation,
        fiberattenuation: (noLimit || !customLimit) ? defaultFiberAttenuation : parseFloat(fiberAttenuation),
        verifylength: verifyLength,
        maxlength: maxLengthInMeters,
        devicetype: null
      };
      if (isTestEdit) {
        this.props.updateFiberLengthLoss(this.props.selectedTest, payload);
        this.props.handleClose();
      } else {
        this.props.updateFiberLengthLoss(payload);
      }
      if (this.state.isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
      this.setState({
        isChanged: false,
        errors: {}
      });
    }
  };

  render() {
    const {
      lengthMeasurementUnit,
      translate,
      classes,
      languages,
      selectedTest,
      isTestEdit,
      fiberlengthlossdetails,
      fiberLengthLoss,
      testEdit,
      modified
    } = this.props;
    const {
      sfpType,
      fiberType,
      connectorType,
      limitType,
      noLimit,
      customLimit,
      validTestLimits,
      validConnectorTypes,
      validFiberTypes,
      testMethod,
      testDirection,
      refractiveIndex,
      verifyLength,
      maxLength,
      defaultMaxLengthLimit,
      spliceCount,
      spliceLoss,
      adapterCount,
      adapterLoss,
      stdAttenuation,
      fiberAttenuation,
      showConfirmBack,
      testMethodTooltipHover,
      testMethodTooltipFocus,
      isChanged,
      errors,
      isRestore
    } = this.state;

    let maxLengthFieldName = translate("maximum_length") + " (";
    maxLengthFieldName += lengthMeasurementUnit === "feet" ? translate("ft") : translate("m");
    maxLengthFieldName += ")";
    return (
      <div display="flex" flexdirection="row" p={1} m={1}  style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("fiberlengthloss_setup")}
          />
        )}
        <Content translate={translate}>
          {fiberLengthLoss && sfpType && (
              <Grid container>
                <Grid item xs={4}>
                  <FormControl fullWidth margin="normal" error={false}>
                    <InputLabel id="sfp-type">{translate("sfp_type")}</InputLabel>
                    <Select
                      labelId="sfp-type"
                      name="sfpType"
                      renderValue={() => this.renderTranslatedValue(sfpType, translate)}
                      onChange={this.onChange}
                      input={
                        <Input value={() => this.renderTranslatedValue(sfpType, translate)} />
                      }
                      autoWidth={false}
                    >
                    {FiberLengthLossEnum.SFPType.map(enumType => {
                        return (
                            <MenuItem key={enumType.value} value={enumType.key}>
                                {translate(enumType.value)}
                            </MenuItem>
                        );
                    })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={4}>
                  <Tooltip
                    title={<h3>{translate("fiber_test_method_info")}</h3>}
                    open={testMethodTooltipHover && !testMethodTooltipFocus}
                    disableTriggerFocus={true}
                    disableTriggerHover={true}
                    disableTriggerTouch={true}
                    onClick={() => {this.setTestMethodTooltipHover(false); this.setTestMethodTooltipFocus(false)}}
                  >
                  <FormControl fullWidth margin="normal" error={false}>
                    <InputLabel id="test-method">{translate("test_method")}&nbsp;&#128712;</InputLabel>
                    <Select
                      labelId="test-method"
                      name="testMethod"
                      renderValue={() => this.renderTranslatedValue(testMethod, translate)}
                      onChange={this.onChange}
                      onMouseOver={() => this.setTestMethodTooltipHover(true)}
                      onMouseLeave={() => this.setTestMethodTooltipHover(false)}
                      onClick={() => this.setTestMethodTooltipFocus(true)}
                      input={
                        <Input value={() => this.renderTranslatedValue(testMethod, translate)} />
                      }
                      autoWidth={false}
                    >
                    {FiberLengthLossEnum.TestMethod.map(enumType => {
                        return (
                            <MenuItem key={enumType.value} value={enumType.key}>
                                {translate(enumType.value)}
                            </MenuItem>
                        );
                    })}
                    </Select>
                  </FormControl>
                  </Tooltip>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth margin="normal" error={false}>
                    <InputLabel id="fiber-type">{translate("fiber_type")}</InputLabel>
                    <Select
                      labelId="fiber-type"
                      name="fiberType"
                      renderValue={() => this.renderValue(fiberType)}
                      onChange={this.onChange}
                      input={
                        <Input value={() => this.renderValue(fiberType)} />
                      }
                      autoWidth={false}
                    >
                    {validFiberTypes.map(enumType => {
                        return (
                            <MenuItem key={enumType.value} value={enumType.key}>
                                {enumType.value}
                            </MenuItem>
                        );
                    })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth margin="normal" error={false}>
                    <InputLabel id="connector-type">{translate("test_connector_type")}</InputLabel>
                    <Select
                      labelId="connector-type"
                      name="connectorType"
                      renderValue={() => this.renderValue(connectorType)}
                      onChange={this.onChange}
                      input={
                        <Input value={() => this.renderValue(connectorType)} />
                      }
                      autoWidth={false}
                    >
                    {validConnectorTypes.map(enumType => {
                        return (
                            <MenuItem key={enumType.value} value={enumType.key}>
                                {enumType.value}
                            </MenuItem>
                        );
                    })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                <TextField
                    className={classes.textField}
                    error={errors.refractiveIndex}
                    label={translate("fiber_refractiveindex")}
                    name="refractiveIndex"
                    margin="normal"
                    value={refractiveIndex}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.refractiveIndex
                        ? translate("subtest_number_range", {
                            start: 1.3000,
                            end: 1.5500
                        })
                        : ""
                    }
                />
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth margin="normal" error={false}>
                    <InputLabel id="test-direction">{translate("fiber_test_direction")}</InputLabel>
                    <Select
                      labelId="test-direction"
                      name="testDirection"
                      renderValue={() => this.renderTranslatedValue(testDirection, translate)}
                      onChange={this.onChange}
                      input={
                        <Input value={() => this.renderTranslatedValue(testDirection, translate)} />
                      }
                      autoWidth={false}
                    >
                    {FiberLengthLossEnum.TestDirection.map(enumType => {
                        return (
                            <MenuItem key={enumType.value} value={enumType.key}>
                                {translate(enumType.value)}
                            </MenuItem>
                        );
                    })}
                    </Select>
                  </FormControl>
                </Grid>
                {noLimit ? <Grid itm xs={4}></Grid> :
                <Grid itm xs={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            (verifyLength !== null || verifyLength !== undefined) ? verifyLength : false
                          }
                          onChange={this.onChange}
                          value="enableMarginValue"
                          color="primary"
                          name="verifyLength"
                        />
                      }
                      label={
                        <Typography className={classes.checkboxLabel}>
                          {translate("fiber_verify_length")}
                        </Typography>
                      }
                    />
                </Grid>}
                <Grid item xs={2}></Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth margin="normal" error={false}>
                    <InputLabel id="test-limit">{translate("fiber_length_loss_limit_type")}</InputLabel>
                    <Select
                      labelId="test-limit"
                      name="limitType"
                      renderValue={() => this.renderLimitType(limitType, translate)}
                      onChange={this.onChange}
                      input={
                        <Input value={() => this.renderLimitType(limitType, translate)} />
                      }
                      autoWidth={false}
                    >
                    {validTestLimits.map(enumType => {
                        return (
                          <MenuItem key={enumType.value} value={enumType.key}>
                                {enumType.value === "test_standard_custom" || enumType.value === "none_constant" ? translate(enumType.value) : enumType.value}
                            </MenuItem>
                        );
                    })}
                    </Select>
                  </FormControl>
                  <Typography className={classes.tinyInfo}>{this.getLimitInfoText(translate)}</Typography>
                </Grid>
                {verifyLength && !noLimit ? <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.maxLength}
                    label={maxLengthFieldName}
                    name="maxLength"
                    margin="normal"
                    value={this.getLimitInfoLengthLimit(maxLength)}
                    onChange={this.onChange}
                    disabled={(this.state.limitType[0] && (parseInt(this.state.limitType[0].key) > 1)) ? true : false}
                    fullWidth
                    helperText={
                        errors.maxLength
                        ? translate("subtest_number_range", {
                            start: 0,
                            end: defaultMaxLengthLimit
                        })
                        : ""
                    }
                />
                </Grid> : <Grid item xs={3}></Grid>}
                <Grid item xs={1}></Grid>
                {customLimit ? 
                <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.spliceCount}
                    label={translate("splice_count")}
                    name="spliceCount"
                    margin="normal"
                    value={spliceCount}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.spliceCount
                        ? translate("subtest_number_range", {
                            start: 0,
                            end: 8
                        })
                        : ""
                    }
                />
                </Grid> : <Grid item xs={3}></Grid>}
                <Grid item xs={1}></Grid>
                {customLimit ? 
                <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.adapterCount}
                    label={translate("adapter_count")}
                    name="adapterCount"
                    margin="normal"
                    value={adapterCount}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.adapterCount
                        ? translate("subtest_number_range", {
                            start: 0,
                            end: 8
                        })
                        : ""
                    }
                />
                </Grid> : <Grid item xs={3}></Grid>}
                {!noLimit && !customLimit ? <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.maxLength}
                    label={translate("fiber_loss_limit") + " (" + translate("dB") + ")"}
                    name="lossLimit"
                    margin="normal"
                    value={this.getLimitInfoLossLimit()}
                    onChange={this.onChange}
                    disabled={true}
                    fullWidth
                />
                </Grid> : <Grid item xs={3}></Grid>}
                <Grid item xs={1}></Grid>
                {customLimit ? 
                <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.spliceLoss}
                    label={translate("splice_loss")}
                    name="spliceLoss"
                    margin="normal"
                    value={spliceLoss}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.spliceLoss
                        ? translate("subtest_number_range", {
                            start: 0.0,
                            end: 5.0
                        })
                        : ""
                    }
                />
                </Grid> : <Grid item xs={3}></Grid>}
                <Grid item xs={1}></Grid>
                {customLimit ? 
                <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.adapterLoss}
                    label={translate("adapter_loss")}
                    name="adapterLoss"
                    margin="normal"
                    value={adapterLoss}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.adapterLoss
                        ? translate("subtest_number_range", {
                            start: 0.0,
                            end: 5.0
                        })
                        : ""
                    }
                />
                </Grid> : <Grid item xs={3}></Grid>}
                <Grid item xs={4}></Grid>
                {noLimit || !customLimit ? <Grid itm xs={3}></Grid> :
                <Grid itm xs={3}>
                    <Tooltip title={<h3>{translate("fiber_std_attenuation_limit_info")}</h3>} disableTriggerFocus={true}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            (stdAttenuation !== null || stdAttenuation !== undefined) ? stdAttenuation : false
                          }
                          onChange={this.onChange}
                          value="enableMarginValue"
                          color="primary"
                          name="stdAttenuation"
                        />
                      }
                      label={
                        <Typography className={classes.checkboxLabel}>
                          {translate("apply_standard_attenuation_limit")}&nbsp;&#128712;
                        </Typography>
                      }
                    />
                    </Tooltip>
                </Grid>}
                <Grid item xs={1}></Grid>
                {noLimit || !customLimit || stdAttenuation ? <Grid item xs={3}></Grid> :
                <Grid item xs={3}>
                <TextField
                    className={classes.textField}
                    error={errors.adapterLoss}
                    label={translate("fiber_attenuation_limit")}
                    name="fiberAttenuation"
                    margin="normal"
                    value={fiberAttenuation}
                    onChange={this.onChange}
                    disabled={false}
                    fullWidth
                    helperText={
                        errors.fiberAttenuation
                        ? translate("subtest_number_range", {
                            start: 0.0,
                            end: 5.0
                        })
                        : ""
                    }
                />
                </Grid>}
                <Grid item xs={3}></Grid>
                <Grid container>
                    <Grid item xs={8}>
                    </Grid>
                    <Grid item xs={4}></Grid>
                </Grid>
                  <br />
                  {!isTestEdit && (
                    <div align="right">
                      <Button
                        className={classes.saveTarget}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={this.onFiberLengthLossSave}
                      >
                        {translate("sub_set_ping_save_target")}
                      </Button>
                    </div>
                  )}
                <Grid item xs={isTestEdit ? 0 : 2}></Grid>
              </Grid>
            )}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: translate("fiberlengthloss")
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit && sfpType && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "inline-block", marginLeft: "20px" }}>
                {fiberlengthlossdetails && !testEdit ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : testEdit && modified ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : null}
              </div>
              <div style={{ display: "inline-block", marginRight: "20px" }}>
                <Button
                  className={classes.saveTarget}
                  disabled={!isChanged}
                  color="accent"
                  raised
                  onClick={() => this.onFiberLengthLossSave()}
                >
                  {translate("general_continue")}
                </Button>
              </div>
            </div>
          )}
      </div>
    );
  }

  // component life cycles 
  componentWillMount() {
    const { getFiberLengthLoss } = this.props;
    getFiberLengthLoss();
  }

  componentWillReceiveProps(nextProps) {
    const { fiberLengthLossInitialised } = this.state
    const { fiberLengthLoss, fiberlengthlossdetails, isTestEdit } = nextProps;
    if (isTestEdit && !fiberlengthlossdetails) {
      if (fiberLengthLoss && this.props.fiberLengthLoss != fiberLengthLoss && !fiberLengthLossInitialised) {
        this.setState({ fiberLengthLossInitialised: true }, this.updateFiberLengthLoss(fiberLengthLoss));
      }
    } else if (isTestEdit && fiberlengthlossdetails) {
      if (
        (fiberlengthlossdetails && this.props.fiberlengthlossdetails != fiberlengthlossdetails) ||
        !this.state.isFiberLengthLossUpdated
      ) {
        this.updateFiberLengthLoss(fiberlengthlossdetails);
        this.setState({ isFiberLengthLossUpdated: true });
      }
    } else {
      if (fiberLengthLoss && this.props.fiberLengthLoss != fiberLengthLoss) {
        this.updateFiberLengthLoss(fiberLengthLoss);
      }
    }
  }


  componentDidMount() {
    window.scrollTo(0, 0)
  }
}

export default withRouter(withStyles(styles)(FiberLengthLoss));
